const Utils = {};

Utils.randomColorGenerator = () => {
    const red = Math.floor(Math.random() * 255);
    const green = Math.floor(Math.random() * 255);
    const blue = Math.floor(Math.random() * 255);

    return { red, green, blue };
};

Utils.arrayfyObject = (obj, { keyToName = 'key' } = {}) => {
    const arr = [];
    for (const [key, value] of Object.entries(obj)) {
        arr.push({ ...value, [keyToName]: key });
    }
    return arr;
};

Utils.dateToDatetimeFormat = date => {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hour = ('0' + date.getHours()).slice(-2);
    const min = ('0' + date.getMinutes()).slice(-2);

    return `${year}-${month}-${day}T${hour}:${min}`;
};

Utils.dateToSimpleDateFormat = date => {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
};

Utils.dateToDatetimeFormatRangeDay = date => {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return { min: `${year}-${month}-${day}T00:00`, max: `${year}-${month}-${day}T21:59` };
};

Utils.calculateItemDistance = item => {
    return (item.distance || 0) * (item.reps || 1);
};

Utils.calculateItemSetDistance = (item, subItems = []) => {
    if (subItems && subItems.length > 0) {
        let setDistance = Utils.calculateItemDistance(item);
        subItems.forEach(subItem => {
            setDistance += Utils.calculateItemDistance(subItem);
        });
        return setDistance * (item.set || 1);
    } else {
        return Utils.calculateItemDistance(item) * (item.set || 1);
    }
};

Utils.calculateTotalProgramDistance = programItems => {
    return programItems.reduce((sum, item) => {
        return sum + Utils.calculateItemSetDistance(item, item.subItems);
    }, 0);
};

Utils.calculateSwimmingStyleStats = (programItems, swimmingStyles) => {
    return swimmingStyles.map(style =>
        programItems.reduce((sum, item) => {
            if (item.subItems && item.subItems.length > 0) {
                let styleDistance = 0;

                if (item.swimmingStyle === style) {
                    styleDistance += Utils.calculateItemDistance(item);
                }

                item.subItems.forEach(subItem => {
                    if (subItem.swimmingStyle === style) {
                        styleDistance += Utils.calculateItemDistance(subItem);
                    }
                });

                return sum + styleDistance * (item.set || 1);
            } else {
                return (
                    sum +
                    (item.swimmingStyle === style
                        ? Utils.calculateItemDistance(item) * (item.set || 1)
                        : 0)
                );
            }
        }, 0)
    );
};

Utils.calculateSetTypeStats = (programItems, setTypes) => {
    return setTypes.map(type =>
        programItems.reduce((sum, item) => {
            if (item.subItems && item.subItems.length > 0) {
                let typeDistance = 0;

                if (item.setType === type) {
                    typeDistance += Utils.calculateItemDistance(item);
                }

                item.subItems.forEach(subItem => {
                    if (subItem.setType === type) {
                        typeDistance += Utils.calculateItemDistance(subItem);
                    }
                });

                return sum + typeDistance * (item.set || 1);
            } else {
                return (
                    sum +
                    (item.setType === type
                        ? Utils.calculateItemDistance(item) * (item.set || 1)
                        : 0)
                );
            }
        }, 0)
    );
};

Utils.calculateZoneStats = (programItems, zones) => {
    return zones.map(zone =>
        programItems.reduce((sum, item) => {
            if (item.subItems && item.subItems.length > 0) {
                let zoneDistance = 0;

                if (item.zones === zone) {
                    zoneDistance += Utils.calculateItemDistance(item);
                }

                item.subItems.forEach(subItem => {
                    if (subItem.zones === zone) {
                        zoneDistance += Utils.calculateItemDistance(subItem);
                    }
                });

                return sum + zoneDistance * (item.set || 1);
            } else {
                return (
                    sum +
                    (item.zones === zone ? Utils.calculateItemDistance(item) * (item.set || 1) : 0)
                );
            }
        }, 0)
    );
};

Utils.formatDuration = (minutes, seconds) => {
    if (!minutes && !seconds) return null;

    const totalSeconds = (Number(minutes) || 0) * 60 + (Number(seconds) || 0);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`;
};

export default Utils;
